import { BaseModel } from "./base/base.model";

export class AppDocumentos extends BaseModel {
    public doc1?: string;
    public origin?: { origin1: string, name: string };
    public name?: string;
    public environment?: string;
    public mimeType?: string;
    public category?: { docCategory1: string, name: string };
    public company?: { company1: string, name: string };
    public docData?: string;
    public modifiedBy?: string;
    public modifiedByData?: { id: string, fullName: string };
    public modifiedOn?: Date;
    public createdAt?: Date;


} 